import Modulo12 from "../pages/modulo12/Modulo12";
import Modulo12Conclusion from "../pages/modulo12/Modulo12Conclusion";
import Modulo12U1A1 from "../pages/modulo12/unidad1/Actividad1";
import Modulo12U1A2 from "../pages/modulo12/unidad1/Actividad2";
import Modulo12U1A3 from "../pages/modulo12/unidad1/Actividad3";
import Modulo12U1A4 from "../pages/modulo12/unidad1/Actividad4";
import Modulo12U1A5 from "../pages/modulo12/unidad1/Actividad5";
import Modulo12U1A6 from "../pages/modulo12/unidad1/Actividad6";
import Modulo12U1A7 from "../pages/modulo12/unidad1/Actividad7";
import Modulo12U1A8 from "../pages/modulo12/unidad1/Actividad8";
import Modulo12U1A9 from "../pages/modulo12/unidad1/Actividad9";
import Modulo12U1A10 from "../pages/modulo12/unidad1/Actividad10";
import Modulo12U1A11 from "../pages/modulo12/unidad1/Actividad11";
import Modulo12U1A12 from "../pages/modulo12/unidad1/Actividad12";
import Modulo12U1A13 from "../pages/modulo12/unidad1/Actividad13";

import Modulo12U2A1 from "../pages/modulo12/unidad2/Actividad1";
import Modulo12U2A2 from "../pages/modulo12/unidad2/Actividad2";
import Modulo12U2A3 from "../pages/modulo12/unidad2/Actividad3";
import Modulo12U2A4 from "../pages/modulo12/unidad2/Actividad4";
import Modulo12U2A5 from "../pages/modulo12/unidad2/Actividad5";
import Modulo12U2A6 from "../pages/modulo12/unidad2/Actividad6";
import Modulo12U2A7 from "../pages/modulo12/unidad2/Actividad7";
import Modulo12U2A8 from "../pages/modulo12/unidad2/Actividad8";
import Modulo12U2A9 from "../pages/modulo12/unidad2/Actividad9";
import Modulo12U2A10 from "../pages/modulo12/unidad2/Actividad10";
import Modulo12U2A11 from "../pages/modulo12/unidad2/Actividad11";
import Modulo12U2A12 from "../pages/modulo12/unidad2/Actividad12";

import Modulo12U3A1 from "../pages/modulo12/unidad3/Actividad1";
import Modulo12U3A2 from "../pages/modulo12/unidad3/Actividad2";
import Modulo12U3A3 from "../pages/modulo12/unidad3/Actividad3";
import Modulo12U3A4 from "../pages/modulo12/unidad3/Actividad4";
import Modulo12U3A5 from "../pages/modulo12/unidad3/Actividad5";
import Modulo12U3A6 from "../pages/modulo12/unidad3/Actividad6";
import Modulo12U3A7 from "../pages/modulo12/unidad3/Actividad7";
import Modulo12U3A8 from "../pages/modulo12/unidad3/Actividad8";
import Modulo12U3A9 from "../pages/modulo12/unidad3/Actividad9";
import Modulo12U3A10 from "../pages/modulo12/unidad3/Actividad10";
import Modulo12U3A11 from "../pages/modulo12/unidad3/Actividad11";
import Modulo12U3A12 from "../pages/modulo12/unidad3/Actividad12";
import Modulo12U3A13 from "../pages/modulo12/unidad3/Actividad13";
import Modulo12U3A14 from "../pages/modulo12/unidad3/Actividad14";

export const modulo12 = {
  title: "¿Quiénes somos los peruanos?",
  grade: { name: "Nivel 3", url: "/nivel-3" },
  module: "Módulo 12",
  year: 'Tercer grado',
  tags: [
    { name: "identidad", url: "identidad" },
    { name: "diversidad", url: "diversidad" },
    { name: "historia del Perú", url: "historia-del-peru" },
  ],
  skills: [
    {
      name: "Construye interpretaciones históricas",
      url: "/construye-interpretaciones-historicas",
    },
  ],
  url: "quienes-somos-los-peruanos",
  component: <Modulo12 />,
  conclusion: <Modulo12Conclusion />,
  color: "red",
  content: [
    {
      name: "Unidad 1: Convivimos",
      path: "unidad-1",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo12U1A1 />,
        },
        {
          name: "Leemos",
          path: "lectura-1",
          component: <Modulo12U1A2 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo12U1A3 />,
        },
        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo12U1A4 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo12U1A5 />,
        },
        {
          name: "Leemos",
          path: "lectura-2",
          component: <Modulo12U1A6 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo12U1A7 />,
        },
        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo12U1A8 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo12U1A9 />,
        },
        {
          name: "Leemos",
          path: "lectura-3",
          component: <Modulo12U1A10 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo12U1A11 />,
        },
        {
          name: "Actividad 9",
          path: "actividad-9",
          component: <Modulo12U1A12 />,
        },
        {
          name: "Leemos",
          path: "lectura-4",
          component: <Modulo12U1A13 />,
        },
      ],
    },
    {
      name: "Unidad 2: Deliberamos",
      path: "unidad-2",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo12U2A1 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo12U2A2 />,
        },
        {
          name: "Leemos",
          path: "lecutra-1",
          component: <Modulo12U2A3 />,
        },

        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo12U2A4 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo12U2A5 />,
        },
        {
          name: "Leemos",
          path: "lectura-2",
          component: <Modulo12U2A6 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo12U2A7 />,
        },
        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo12U2A8 />,
        },
        {
          name: "Leemos",
          path: "lectura-3",
          component: <Modulo12U2A9 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo12U2A10 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo12U2A11 />,
        },
        {
          name: "Leemos",
          path: "lectura-4",
          component: <Modulo12U2A12 />,
        },
      ],
    },
    {
      name: "Unidad 3: Participamos",
      path: "unidad-3",
      activities: [
        {
          name: "Actividad 1",
          path: "actividad-1",
          component: <Modulo12U3A1 />,
        },
        {
          name: "Actividad 2",
          path: "actividad-2",
          component: <Modulo12U3A2 />,
        },
        {
          name: "Leemos",
          path: "lectura-1",
          component: <Modulo12U3A3 />,
        },

        {
          name: "Actividad 3",
          path: "actividad-3",
          component: <Modulo12U3A4 />,
        },
        {
          name: "Actividad 4",
          path: "actividad-4",
          component: <Modulo12U3A5 />,
        },
        {
          name: "Actividad 5",
          path: "actividad-5",
          component: <Modulo12U3A6 />,
        },
        {
          name: "Leemos",
          path: "Lectura-2",
          component: <Modulo12U3A7 />,
        },

        {
          name: "Actividad 6",
          path: "actividad-6",
          component: <Modulo12U3A8 />,
        },
        {
          name: "Actividad 7",
          path: "actividad-7",
          component: <Modulo12U3A9 />,
        },
        {
          name: "Actividad 8",
          path: "actividad-8",
          component: <Modulo12U3A10 />,
        },
        {
          name: "Leemos",
          path: "lectura-3",
          component: <Modulo12U3A11 />,
        },

        {
          name: "Actividad 9",
          path: "actividad-9",
          component: <Modulo12U3A12 />,
        },
        {
          name: "Actividad 10",
          path: "actividad-10",
          component: <Modulo12U3A13 />,
        },
        {
          name: "Leemos",
          path: "lectura-4",
          component: <Modulo12U3A14 />,
        },
      ],
    },
  ],
};
